const APP_NAME = "Nettwerk Communities";

export {APP_NAME}